(function () {
  var pixelReadyAttempts = 0;
  var maxPixelReadyAttempts = 80;
  var recentlyMeasured = {};

  function getCurrency() {
    return (
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.theme && window.theme.settings && window.theme.settings.currencyCode) ||
      'USD'
    );
  }

  function normalizeAmount(value) {
    var number = Number(value);

    if (!Number.isFinite(number)) {
      return 0;
    }

    return Math.round((number / 100) * 100) / 100;
  }

  function measure(eventName, payload, dedupeKey) {
    if (typeof window.oaiq !== 'function') {
      if (pixelReadyAttempts < maxPixelReadyAttempts) {
        pixelReadyAttempts += 1;
        setTimeout(function () {
          measure(eventName, payload, dedupeKey);
        }, 250);
      }

      return;
    }

    if (dedupeKey) {
      var now = Date.now();
      var previous = recentlyMeasured[dedupeKey];

      if (previous && now - previous < 1500) {
        return;
      }

      recentlyMeasured[dedupeKey] = now;
    }

    window.oaiq('measure', eventName, Object.assign({
      type: 'customer_action',
      amount: 0,
      currency: getCurrency()
    }, payload || {}));
  }

  function measurePageView() {
    measure('page_viewed', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname
    }, 'page_viewed:' + window.location.href);
  }

  function measureAddToCart(cartAddResponse) {
    var firstItem = cartAddResponse && cartAddResponse.items
      ? cartAddResponse.items[0]
      : cartAddResponse;
    var quantity = firstItem && firstItem.quantity ? firstItem.quantity : 1;
    var variantId = firstItem && (firstItem.variant_id || firstItem.id);
    var amount = firstItem && (
      firstItem.final_line_price ||
      firstItem.line_price ||
      (firstItem.final_price * quantity) ||
      (firstItem.price * quantity)
    );

    measure('items_added', {
      amount: normalizeAmount(amount),
      currency: getCurrency(),
      item_id: variantId ? String(variantId) : undefined,
      item_name: firstItem && firstItem.product_title,
      quantity: quantity
    }, 'items_added:' + (variantId || 'unknown') + ':' + quantity);
  }

  function isCartAddUrl(url) {
    if (!url) {
      return false;
    }

    var href = typeof url === 'string' ? url : url.url;

    return href && href.indexOf('/cart/add') !== -1;
  }

  function patchFetchAddToCart() {
    if (!window.fetch) {
      return;
    }

    var originalFetch = window.fetch;

    window.fetch = function () {
      var requestUrl = arguments[0];

      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartAddUrl(requestUrl) && response && response.ok) {
          response.clone().json().then(function (data) {
            if (!data || data.status === 422) {
              return;
            }

            measureAddToCart(data);
          }).catch(function () {});
        }

        return response;
      });
    };
  }

  function patchXhrAddToCart() {
    if (!window.XMLHttpRequest) {
      return;
    }

    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this._openAiTrackingUrl = url;
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (isCartAddUrl(this._openAiTrackingUrl)) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) {
            return;
          }

          try {
            var data = JSON.parse(this.responseText);

            if (data && data.status !== 422) {
              measureAddToCart(data);
            }
          } catch (error) {}
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  function getContactLeadType(link) {
    var href = link && link.getAttribute('href');

    if (!href) {
      return '';
    }

    if (href.indexOf('tel:') === 0) {
      return 'call';
    }

    if (href.indexOf('mailto:') === 0) {
      return 'email';
    }

    return '';
  }

  function trackLeadClicks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href^="tel:"], a[href^="mailto:"]');
      var leadType = getContactLeadType(link);

      if (!leadType) {
        return;
      }

      measure('lead_created', {
        lead_type: leadType,
        lead_source: 'storefront_link',
        page_location: window.location.href
      }, 'lead_created:' + leadType + ':' + link.getAttribute('href'));
    });
  }

  function trackContactFormSuccess() {
    var params = new URLSearchParams(window.location.search);
    var contactPosted = params.get('contact_posted') === 'true';
    var pendingLead = window.sessionStorage.getItem('openai_contact_form_pending');

    if (!contactPosted || !pendingLead) {
      return;
    }

    window.sessionStorage.removeItem('openai_contact_form_pending');

    measure('lead_created', {
      lead_type: 'form_submission',
      lead_source: pendingLead,
      page_location: window.location.href
    }, 'lead_created:form_submission:' + window.location.href);
  }

  function trackContactFormSubmits() {
    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!form || !form.matches('form[action*="/contact"], form[action*="contact"]')) {
        return;
      }

      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        return;
      }

      window.sessionStorage.setItem('openai_contact_form_pending', form.id || form.getAttribute('action') || 'contact_form');
    }, true);
  }

  function init() {
    measurePageView();
    patchFetchAddToCart();
    patchXhrAddToCart();
    trackLeadClicks();
    trackContactFormSuccess();
    trackContactFormSubmits();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
